import { FigmakeTimesheet } from '@/components/figmamake';

export default function FigmakeTimesheetPage() {
  return <FigmakeTimesheet />;
}
